module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAALJJREFUWEfd17EOgCAMBFD60YRRGPlqTE1YTFTaXm2UxcHhXq6QAKXgRcH56Z+A3nvlZkspx/duwRvgcCLaxhjtdYA0nJuBNaAJhwG04RCAJdwMsIabADOciGrOuT0dt6v/qk2IClc1gAwXAxAzP49ieQQe4csNeIV/B8BSrxaW94AXQgTwQIgBaIQKgESoASiECYBAmAFWBARgQcAAWgQUoEHAARMR9jCRXs1cGpAgwgE7JS6/IRwpv8EAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/left_2.png
// module id = iSgu
// module chunks = 1